import React from 'react';
import clsx from 'clsx';
import PopupTitle from '../PopupTitle';
import PopupContent from '../PopupContent';
import PopupActions from '../PopupActions';
import ButtonContained from '../Button/ButtonContained';
import TooltipDialogSC from './styles/TooltipDialogSC';
import BackDrop from '../Modal/BackDrop';
import factoryTooltip from './utils/factoryTooltip';
const RenderModalTooltip = (props) => {
    const { title, content, actions, onActions } = props;
    const firstAction = actions[0];
    const secondAction = actions[1];
    const onFirstAction = onActions[0];
    const onSecondAction = onActions[1];
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "_ndsTooltip__content" },
            React.createElement(PopupTitle, null, title),
            React.createElement(PopupContent, null, content),
            React.createElement(PopupActions, null,
                firstAction && (React.createElement(ButtonContained, { onClick: onFirstAction, color: "grey", type: "button" }, firstAction)),
                secondAction && (React.createElement(ButtonContained, { onClick: onSecondAction, type: "button" }, secondAction))))));
};
const TooltipModal = (props) => {
    const { title, content, actions, onActions, forwardedRef, rootStyle = {}, placement, arrowProps = {}, className: classNameProp } = props;
    return (React.createElement(React.Fragment, null,
        React.createElement(BackDrop, { open: true, className: "_ndsTooltip__backdrop" }),
        React.createElement(TooltipDialogSC, { ref: forwardedRef, style: rootStyle, "data-placement": placement, className: clsx('_ndsTooltip', classNameProp) },
            React.createElement(RenderModalTooltip, { title: title, content: content, actions: actions, onActions: onActions }),
            React.createElement("div", { ref: arrowProps.ref, style: arrowProps.style, className: "_ndsTooltip__arrow" }))));
};
export default factoryTooltip(TooltipModal, 'modal');
//# sourceMappingURL=TooltipModal.js.map